export const FANCLUB = "FANCLUB";
export const MANAGER = "MANAGER";
export const AUTOMANAGER = "AUTOMANAGER";
